import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { NEW_PLANS, PRICING_PATHS } from "@/content/pricing/plans";
import { usePricingCopy } from "@/content/pricing";
import { PlanCard } from "@/pages/Pricing2026";

/**
 * The home page's plans: the same cards as /pricing (the pricing from 1 November 2026), linking to the full page.
 * The pricing copy is in every site language (src/content/pricing).
 */
const PricingSection = () => {
  const loc = usePricingCopy();
  const p = loc.copy.pricing;
  return (
    <section id="pricing" className="py-24 bg-background" aria-labelledby="home-plans-heading">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-14 max-w-2xl text-center">
          <h2 id="home-plans-heading" className="mb-3 text-3xl font-display font-bold md:text-4xl">
            {p.plans.heading}
          </h2>
          <p className="text-muted-foreground">{p.plans.subtitle}</p>
        </div>
        <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-3 md:gap-6">
          {NEW_PLANS.map((plan) => (
            <PlanCard key={plan.id} plan={plan} loc={loc} />
          ))}
        </div>
        <p className="mt-10 text-center">
          <Link to={`${PRICING_PATHS.pricing}#compare-features`} className="inline-flex items-center gap-1.5 font-semibold text-hawk-orange hover:underline">
            {p.compare.linkLabel}
            <ArrowRight size={16} />
          </Link>
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
